import * as Actions from './member-professional-domicile.actions';

export const MemberProfessionalDomicileActions = Actions;
